module.exports = __webpack_public_path__ + "img/logo-stripe.fa9db2d0.png";